import type { ImageDeliverable } from '@bizzdesign/modeler/models';
import { toImageClassificationFields } from '@bizzdesign/modeler/utils-canvazz';
import { signalStoreFeature } from '@ngrx/signals';
import { on, withReducer } from '@ngrx/signals/events';
import { imagesAPIEvents } from '@bizzdesign/modeler/utils-canvazz/browser';
import { type ImageState } from './image.store';
import {
  toImageDeliverable,
  trimImageCache,
  upsertImages,
} from './image.store.utils';

export function withImageReducer() {
  return signalStoreFeature(
    withReducer(
      on(
        imagesAPIEvents.frameImagesLoaded,
        ({ payload }) =>
          (state: ImageState) => {
            const newEntries = payload.flatMap((item) => {
              const deliverable = toImageDeliverable(item);
              return deliverable === undefined ? [] : [deliverable];
            });

            return trimImageCache(
              upsertImages(state.images, newEntries),
              state.evictableImageIds,
            );
          },
      ),
      on(
        imagesAPIEvents.updateImageMetadata,
        ({ payload }) =>
          (state: ImageState) => {
            const newEntries = payload.flatMap((item) => {
              const deliverable = toImageDeliverable(item);
              return deliverable === undefined ? [] : [deliverable];
            });

            return trimImageCache(
              upsertImages(state.images, newEntries),
              state.evictableImageIds,
            );
          },
      ),
      on(
        imagesAPIEvents.imageUploadSuccess,
        ({
          payload: {
            imageDeliverableId: id,
            imageSrc,
            description,
            alt,
            ...classificationFields
          },
        }) =>
          (state: ImageState) => {
            const nextImage: ImageDeliverable = {
              id,
              imageSrc,
              ...(description === undefined ? {} : { description }),
              ...(alt === undefined ? {} : { alt }),
              ...toImageClassificationFields(classificationFields),
            };

            return trimImageCache(
              upsertImages(state.images, [nextImage]),
              state.evictableImageIds,
            );
          },
      ),
    ),
  );
}
